// extracted by mini-css-extract-plugin
export var container = "iso-accreditations-module--container--fa2d4";
export var text = "iso-accreditations-module--text--31125";
export var title = "iso-accreditations-module--title--0dd98";